import React from 'react';
import styled from '@benzinga/themetron';
import { Button } from '@benzinga/core-ui';
import { checkDeviceType } from '@benzinga/device-utils';
import Hooks from '@benzinga/hooks';

export interface ReadInAppButtonProps {
  className?: string;
  url?: string;
}

const appleAppStoreLink = 'https://apps.apple.com/us/app/benzinga-financial-news-data/id688949481';
const googlePlayStorelink = 'https://play.google.com/store/apps/details?id=com.benzinga.app';

export const ReadInAppButton: React.FC<ReadInAppButtonProps> = ({ className = '' }) => {
  const isApple = Hooks.useHydrate(checkDeviceType().isApple(), false);

  const linkToStore = isApple ? appleAppStoreLink : googlePlayStorelink;
  const dataAction = isApple ? 'Download on Apple App Store Click' : 'Download on Google Play Store Click';

  return (
    <Container
      className={`read-in-app-button-container ${className}`}
      data-action={dataAction}
      href={linkToStore}
      target="_blank"
    >
      <Button className="read-in-app-button" variant="primary">
        Read in App
      </Button>
    </Container>
  );
};

const Container = styled.a`
  &.read-in-app-button-wrapper {
    height: 40px;
    display: flex;
    align-items: center;

    .read-in-app-button {
      height: 35px;
      padding: 0 20px;
    }
  }
`;

export default ReadInAppButton;
